import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'login-1',
        path: `${AUTH_PREFIX_PATH}/login-1`,
        component: React.lazy(() => import('views/auth-views/authentication/login-1')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    },
    {
        key: 'error-page-1',
        path: `${AUTH_PREFIX_PATH}/error-page-1`,
        component: React.lazy(() => import('views/auth-views/errors/error-page-1')),
    },
    {
        key: 'dnd-sms',
        path: `/dnd/sms`,
        component: React.lazy(() => import('views/dnd-views/dndSms')),
    },
]

export const protectedRoutes = [
    {
        key: 'home',
        path: `/home`,
        component: React.lazy(() => import('views/app-views/dashboards/')),
    },
    {
        key: 'listReport',
        path: `/home/list-reports`,
        component: React.lazy(() => import('views/app-views/dashboards/')),
    },
    {
        key: 'alibabaCloudLeads',
        path: `/home/alibaba-cloud-leads`,
        component: React.lazy(() => import('views/app-views/dashboards/')),
    },
    {
        key: 'changePassword',
        path: `/admin/change-password`,
        component: React.lazy(() => import('views/app-views/admin/ChangePasword')),
    },
    {
        key: 'admin',
        path: `/admin/timezone`,
        component: React.lazy(() => import('views/app-views/admin/timezone')),
    },
    {
        key: 'admin.timezone',
        path: `/admin/timezone`,
        component: React.lazy(() => import('views/app-views/admin/timezone')),
    },
    {
        key: 'admin.services.phoneNumbers',
        path: `/admin/configure-service/phone-number-services`,
        component: React.lazy(() => import('views/app-views/admin/services/phoneNumberServices')),
    },
    {
        key: 'admin.services.message',
        path: `/admin/configure-service/messaging-services`,
        component: React.lazy(() => import('views/app-views/admin/services/messagingServices')),
    },
    {
        key: 'report.campaign',
        path: `/report/campaign`,
        component: React.lazy(() => import('views/app-views/reports/campaignReport')),
    },
    {
        key: 'report.campaign.call',
        path: `/report/campaign/call/:campaignDetailsID`,
        component: React.lazy(() => import('views/app-views/reports/campaignReport/CallCampaignReport')),
    },
    {
        key: 'report.campaign.sms',
        path: `/report/campaign/sms/:campaignDetailsID`,
        component: React.lazy(() => import('views/app-views/reports/campaignReport/SmsCampaignReport')),
    },
    {
        key: 'report.campaign.whatsapp',
        path: `/report/campaign/whatsapp/:campaignDetailsID`,
        component: React.lazy(() => import('views/app-views/reports/campaignReport/WhatsAppCampaignReport')),
    },
    {
        key: 'report.campaign.email',
        path: `/report/campaign/email/:campaignDetailsID`,
        component: React.lazy(() => import('views/app-views/reports/campaignReport/EmailCampaignReport')),
    },
    {
        key: 'report.previewcampaign',
        path: `/report/preview-campaign`,
        component: React.lazy(() => import('views/app-views/reports/previewcampaignReport')),
    },
    {
        key: 'report.campaign.previewcampaigndetails',
        path: `/report/preview-campaign/details/:campaignDashboardID`,
        component: React.lazy(() => import('views/app-views/reports/previewcampaignReport/PreviewCampaignDetails')),
    },

    {
        key: 'report.taskagentreport',
        path: `/report/task-agent-report`,
        component: React.lazy(() => import('views/app-views/reports/taskagentReport')),
    },
    {
        key: 'report.contactlistreport',
        path: `/report/contact-list-report`,
        component: React.lazy(() => import('views/app-views/reports/contactlistReport')),
    },
    {
        key: 'report.contactlistdetails',
        path: `/report/contact-list-report/details/:contactListId`,
        component: React.lazy(() => import('views/app-views/reports/contactlistReport/ContactDetails')),
    },
    {
        key: 'report.smstemplatereport',
        path: `/report/sms-template-report`,
        component: React.lazy(() => import('views/app-views/reports/smstemplateReport')),
    },
    {
        key: 'report.emailtemplatereport',
        path: `/report/email-template-report`,
        component: React.lazy(() => import('views/app-views/reports/emailtemplateReport')),
    },
    {
        key: 'report.whatsApptemplatereport',
        path: `/report/whatsapp-template-report`,
        component: React.lazy(() => import('views/app-views/reports/whatsApptemplateReport')),
    },
    {
        key: 'admin.contentTemplateBuilder',
        path: '/admin/content-template-builder',
        component: React.lazy(() => import('views/app-views/admin/contentTemplate/ContentTemplateBuilder')),
    },//added these on 30-10-2025
    {
        key: 'admin.contentTemplate.create',
        path: '/admin/content-template-builder/new',
        component: React.lazy(() => import('views/app-views/admin/contentTemplate/ContentTemplateCreate')),
    },//added these on 30-10-2025
    {
        key: 'admin.contentTemplate.configure',
        path: '/admin/content-template-builder/new/configure',
        component: React.lazy(() => import('views/app-views/admin/contentTemplate/ContentTemplateConfigure')),
    },//added these on 30-10-2025
    {
        key: 'admin.contentTemplate.detail',
        path: '/admin/content-template-builder/:sid',
        component: React.lazy(() => import('views/app-views/admin/contentTemplate/ContentTemplateDetail')), // create this file/component
    },//added these on 30-10-2025
    {
        key: 'report.dndreport',
        path: `/report/dnd-report`,
        component: React.lazy(() => import('views/app-views/reports/dndReport')),
    },
    {
        key: 'report.userreport',
        path: `/report/user-report`,
        component: React.lazy(() => import('views/app-views/reports/userReport')),
    },
    {
        key: 'report.userrolereport',
        path: `/report/user-role-report`,
        component: React.lazy(() => import('views/app-views/reports/userRoleReport')),
    },
    {
        key: 'report.blendedReport',
        path: `/report/blended-inbound-report`,
        component: React.lazy(() => import('views/app-views/reports/blendedReport')),
    },
    {
        key: 'report.agentPerformanceReport',
        path: `/report/agent-performance-report`,
        component: React.lazy(() => import('views/app-views/reports/agentPerformanceReport')),
    },
    {
        key: 'resource',
        path: `/resource`,
        component: React.lazy(() => import('views/app-views/resource')),
    },
    {
        key: 'resource.contacts',
        path: `/resource/contact-services/:contactListID`,
        component: React.lazy(() => import('views/app-views/resource/contactServices')),
    },
    {
        key: 'admin.services.message-detail',
        path: `/admin/messaging-services/:name/:id`, 
        component: React.lazy(() => import('views/app-views/admin/services/messageServiceDetails')),
    },    
 
    {
        key: 'admin.campaigns',
        path: `${APP_PREFIX_PATH}/campaigns/campaign`,
        component: React.lazy(() => import('views/app-views/campaigns/Campaign')),
    },
    {
        key: 'admin.campaign.call',
        path: `${APP_PREFIX_PATH}/campaign/call/:campaignDetailsID/:name`,
        component: React.lazy(() => import('views/app-views/campaigns/viewCall')),
    },
    {
        key: 'admin.campaign.sms',
        path: `${APP_PREFIX_PATH}/campaign/sms/:campaignDetailsID/:name`,
        component: React.lazy(() => import('views/app-views/campaigns/viewSms')),
    },
    {
        key: 'admin.campaign.email',
        path: `${APP_PREFIX_PATH}/campaign/email/:campaignDetailsID/:name`,
        component: React.lazy(() => import('views/app-views/campaigns/viewEmail')),
    },
    {
        key: 'admin.campaign.whatsapp',
        path: `${APP_PREFIX_PATH}/campaign/whatsapp/:campaignDetailsID/:name`,
        component: React.lazy(() => import('views/app-views/campaigns/viewWhatsapp')),
    },
    {
        key: 'admin.preview-campaigns',
        path: `${APP_PREFIX_PATH}/campaign/preview-campaign`,
        component: React.lazy(() => import('views/app-views/previewCampaign/previewCampaign')),
    },
    {
        key: 'admin.resource.action',
        path: `${APP_PREFIX_PATH}/resource/action`,
        component: React.lazy(() => import('views/app-views/campaigns/ActionTable')),
    },
    {
        key: 'admin.campaigns.action',
        path: `${APP_PREFIX_PATH}/campaigns/campaign/action`,
        component: React.lazy(() => import('views/app-views/campaigns/ActionTable')),
    },
    {
        key: 'admin.campaigns.action',
        path: `${APP_PREFIX_PATH}/campaign/preview-campaign/action`,
        component: React.lazy(() => import('views/app-views/campaigns/ActionTable')),
    },
    {
        key: 'admin.preview-campaigns-details',
        path: `${APP_PREFIX_PATH}/campaign/preview-campaign/preview-details/:id/:name`, 
        component: React.lazy(() => import('views/app-views/previewCampaign/previewDetails')),
      },
      
    {
        key: 'admin.dnd',
        path: `/admin/dnd`, 
        component: React.lazy(() => import('views/app-views/admin/dnd')),
    },  
    {
        key: 'admin.users',
        path: `/admin/users`, 
        component: React.lazy(() => import('views/app-views/admin/users')),
    },    
    {
        key: 'admin.userRoles',
        path: `/admin/user-roles`, 
        component: React.lazy(() => import('views/app-views/admin/userRoles')),
    },    
    {
        key: 'admin.email',
        path: `/admin/email-templates`,  
        component: React.lazy(() => import('views/app-views/admin/email')),
    }, 
    {
        key: 'admin.sms',
        path: `/admin/sms-templates`,  
        component: React.lazy(() => import('views/app-views/admin/sms')),
    }, 
    {
        key: 'admin.smsContentTempMapping',
        path: `/admin/sms-content-temp-mapping`,
        component: React.lazy(() => import('views/app-views/admin/smsContentTempMapping')),
    },
    {
        key: 'admin.whatsapp',
        path: `/admin/whatsapp-templates`,  
        component: React.lazy(() => import('views/app-views/admin/whatsapp')),
    },
     {
        key: 'admin.whatsappContent',
        path: `/admin/whatsapp-content-templates`,  
        component: React.lazy(() => import('views/app-views/admin/whatsappContent')),
    }, 
    {
        key: 'admin.twilioConfig',
        path: `/admin/telephony-config`,   
        component: React.lazy(() => import('views/app-views/admin/twilioConfig')),
    },    
    
]   